import type { ResponseError } from "@covertree/utils";
import { graphqlOperation } from "@covertree/graphql";
import * as queries from "@graphql/queries";
import * as customQueries from "@graphql/custom/queries";
import * as mutations from "@graphql/mutations";
import * as customMutations from "@graphql/custom/mutations";

export type OperationName =
  | keyof typeof queries
  | keyof typeof customQueries
  | keyof typeof mutations
  | keyof typeof customMutations;
type BaseOperationArgs = { operationName: OperationName; data: unknown };

const allOperations = {
  ...queries,
  ...customQueries,
  ...mutations,
  ...customMutations,
};

export const graphqlBaseOperation =
  () =>
  async ({ operationName, data }: BaseOperationArgs) => {
    try {
      const result = await graphqlOperation(allOperations[operationName], data);

      return { data: result };
    } catch (err) {
      const errors = (err as { errors: ResponseError[] }).errors ?? [];
      const error =
        errors.length > 0
          ? errors.map((e) => ({
              message: e.message,
            }))
          : [
              {
                message:
                  err instanceof Error
                    ? err.message
                    : JSON.stringify(err, Object.getOwnPropertyNames(err)),
              },
            ];

      console.error("GraphQL operation failed", { operationName, error });

      return { error };
    }
  };
